import type { AxiosProgressEvent, AxiosResponse } from 'axios';
import type { MediaDataObject } from '#models/services';
import { useMutation } from '#react-query';
import { createMedia } from '../../services';

type MediaUploadProgressEvent = {
  percent: number;
} & AxiosProgressEvent;

type UploadFile = {
  file: Blob | File;
  onProgress?: (event: MediaUploadProgressEvent) => void;
  signal?: AbortSignal;
};

export const useUploadFileMutation = () =>
  useMutation<AxiosResponse<MediaDataObject>, Error, UploadFile>({
    mutationFn: async ({ file, onProgress, signal }: UploadFile) => createMedia({ file, onProgress, signal }),
  });
